import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="isLoading" class="loader-overlay">
      <img src="../assets/icons/mobileloader2.gif" alt="Chargement..." class="loader-gif">
    </div>
  `,
  styles: [`
    .loader-overlay {
      position: fixed;
      top:0; left:0; width:100%; height:100%;
      display:flex; justify-content:center; align-items:center;
      background: rgba(255,255,255,0.8);
      z-index:9999;
    }
    .loader-gif {
      width: 100px;  /* ajuste selon ton GIF */
      height: 100px; /* ajuste selon ton GIF */
    }
  `]
})
export class LoaderComponent {
  @Input() isLoading = false;
}
